import type { ComponentChildren } from 'preact';
import { cn, type UiBaseProps } from './types';

type CardPadding = 'sm' | 'md' | 'lg' | 'flush';

interface CardProps extends UiBaseProps {
  children: ComponentChildren;
  padding?: CardPadding;
  as?: 'div' | 'section' | 'article';
}

const paddingClass: Record<CardPadding, string | undefined> = {
  sm: 'ui-card--padding-sm',
  md: undefined,
  lg: 'ui-card--padding-lg',
  flush: 'ui-card--flush',
};

/** Surface container with border, radius, and shadow. */
export function Card({
  children,
  className,
  padding = 'md',
  as: Tag = 'div',
}: CardProps) {
  return (
    <Tag className={cn('ui-card', paddingClass[padding], className)}>
      {children}
    </Tag>
  );
}
